export const DOWNLOAD_CONTRACT_ERROR_TITLE = 'Ocorreu um erro'

export const DOWNLOAD_CONTRACT_ERROR_MESSAGE =
  'Ops! Ocorreu um erro inesperado. Tente novamente mais tarde.'

export const MY_CREDIT_CARDS_ERROR_TITLE = 'Ocorreu um erro'

export const MY_CREDIT_CARDS_ERROR_MESSAGE =
  'Ops! Ocorreu um erro inesperado. Tente novamente mais tarde.'

export const MY_CREDIT_CARDS_REDIRECT_DESCRIPTION =
  'Você será redirecionado para a tela de gerenciamento do pagamento recorrente.'

export const MY_CREDIT_CARDS_REDIRECT_BUTTON_LABEL = 'Ir para o site'
